module.exports = __webpack_public_path__ + "img/20200529_142704.d1bd63eb.jpg";